import { render, staticRenderFns } from "./stuInfoQuery.vue?vue&type=template&id=2c73363a"
import script from "./stuInfoQuery.vue?vue&type=script&lang=js"
export * from "./stuInfoQuery.vue?vue&type=script&lang=js"
import style0 from "./stuInfoQuery.vue?vue&type=style&index=0&id=2c73363a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports